<template>
    <img
        :src="src || asset('/img/avatar_default_user.png')"
        :onerror="'this.onerror=null; this.src=\'' + asset('/img/avatar_default_user.png') + '\''"
    />
</template>

<script>
export default {
    props: ['src'],
}
</script>